import { FC, useState } from 'react';
import ParticularClient from '../../ParticularClient';
import { TransferReservationType } from 'app/viaje/viajeTraslado/viajeTraslado/models/TransferReservationPartial';
import { ViajeTrasladoTipoServicio } from 'app/viaje/models';
interface TravelsIdsForClientProps {
  client: {
    name: string;
    companyName?: string;
    type: TransferReservationType;
    service: ViajeTrasladoTipoServicio;
  };
  groupIds: number[];
}
const TravelsIdsForClient: FC<TravelsIdsForClientProps> = ({
  client,
  groupIds
}) => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <div
      className="relative"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        className="flex items-center p-2 cursor-pointer "
        style={{
          transition: 'transform 0.3s ease-out',
          boxShadow: isHovered
            ? '0px 2px 5px rgba(245, 73, 39, 0.5)'
            : '0px 1px 3px rgba(59, 130, 246, 0.5)',
          border: isHovered ? '1px solid #F54927' : 'none',
          borderRadius: '8px'
        }}
      >
        <ParticularClient
          isMobileOrTablet={false}
          client={{
            name: client.name,
            companyName: client.companyName ?? '',
            type: client.type,
            service: client.service
          }}
        />
        <svg
          className="flex w-4 h-4 text-gray-500 transition-transform"
          fill="none"
          stroke="#3B82F6"
          viewBox="0 0 24 24"
          style={{
            transition: 'transform 0.3s ease-out',
            transform: isHovered ? 'rotate(180deg)' : 'rotate(0deg)',
            marginLeft: '-2px'
          }}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </div>
      <div
        className="absolute top-full left-0 transition-all duration-300 ease-out z-50 bg-white border border-gray-200 rounded-lg shadow-lg max-h-96 overflow-y-auto"
        style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          width: '100%',
          padding: '4px',
          opacity: isHovered ? 1 : 0,
          visibility: isHovered ? 'visible' : 'hidden',
          transform: isHovered ? 'translateY(0)' : 'translateY(-10px)',
          transition:
            'opacity 0.3s ease-out, visibility 0.3s ease-out, transform 0.3s ease-out',
          zIndex: 50
        }}
      >
        <div className="flex flex-wrap gap-2 justify-around">
          {groupIds.map((id) => (
            <div
              key={id}
              className="px-2 py-1 text-xs text-gray-700 bg-gray-50 border border-gray-200 rounded "
            >
              {id}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TravelsIdsForClient;
